export const endpoints = {
  FORMA: '/v1/form/create',
  OLD_FORM: '/v1/form',
  ONE_FORM: '/v1/form/one',
  GALLERY: '/v1/form/gallery'
};
